module.exports = __webpack_public_path__ + "static/media/banner1.c051d66f.jpg";